import { Component } from '@angular/core';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-main-menu-page-mobie',
  standalone: false,
  templateUrl: './main-menu-page-mobie.component.html',
  styleUrl: './main-menu-page-mobie.component.css'
})
export class MainMenuPageMobieComponent {
 
  menuItems = [
    // { path: "touchConnect", label: "MENU.USER_LINKS", icon: "🔗" },
    { path: "EmailDevelery", label: "MENU.NOTIFICATION_SETTINGS", icon: "🔔" },
    { path: "UserInterestManu", label: "MENU.USER_INTEREST", icon: "❤️" },
    { path: "userContacts", label: "MENU.USER_CONTACTS", icon: "📇" },
    { path: "bussinessLeadPage", label: "MENU.BUSINESS_LEADS", icon: "💼" },
    { path: "BusinessInsights", label: "MENU.BUSINESS_INSIGHTS", icon: "📊" },
    { path: "EconomicAssistance", label: "MENU.AI_ASSISTANCE", icon: "🤖" },
    { path: "EconimicNews", label: "MENU.ECONOMIC_NEWS", icon: "📰" },
    //{ path: "analytics", label: "MENU.ANALYTICS", icon: "📈" },
    // { path: "setting", label: "MENU.SETTINGS", icon: "⚙️" },
    // { path: "register", label: "MENU.REGISTER", icon: "📝" },
    // { path: "forgot", label: "MENU.FORGOT_PASSWORD", icon: "🔑" },
  ];
  getIcon(path: string): string {
    const iconMap: { [key: string]: string } = {
      "UserInterestManu": "bi bi-heart text-primary",  // Example: Heart icon for interests
      
      "register": "bi bi-person-plus text-primary",  
      "forgot": "bi bi-key text-primary",  
      // "setting": "bi bi-gear text-primary",  
      "analytics": "bi bi-bar-chart text-primary",  
      "newsProvider/:id": "bi bi-newspaper text-primary",  
      
      // "touchConnect":"pi pi-external-link text-primary",
      "userContacts":"fa-solid fa-address-book text-primary",
      "EconomicAssistance":"fa-solid fa-wand-magic-sparkles text-primary",
      "EconimicNews":"fa-solid fa-shekel-sign text-primary",
      "bussinessLeadPage":"fas fa-briefcase text-primary",
      "BusinessInsights":"fas fa-chart-line text-primary"
    };
    return iconMap[path] || "bi bi-circle"; 
  }
userRole:string
constructor(private auth:AuthService){
    this.userRole=this.auth.getRoles();
}


}
